export enum META_KEY {
  OVERRIDE_GLOBAL_ERROR_HANDLER = 'overrideGlobalErrorHandler',
}
